<template>
  <!-- <el-dialog class="rt-lookup-dialog" width="33.3%" :close-on-click-modal="false" title="查找" :visible.sync="dialogVisible"> -->
  <el-dialog
    append-to-body
    class="rtportal rt-lookup-dialog"
    :close-on-click-modal="false"
    :title="$tx('查找', 'lookup.lookup')"
    :visible.sync="dialogVisible"
  >
    <el-row style="display: flex; align-items: center">
      <el-col :span="4">{{ $tx("搜索", "lookup.search") }}</el-col>
      <el-col :span="20" style="margin-left: -60px">
        <el-input
          v-model="filterValue"
          @keyup.enter.native="handleSearch"
          :placeholder="$tx('搜索记录', 'lookup.searchRecords')"
        >
          <el-button
            type="text"
            slot="append"
            icon="el-icon-search"
            style="margin-top: -12px"
            @click="handleSearch"
          ></el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-table
      ref="lookupTable"
      style="width: 100%"
      height="30%"
      :row-class-name="tabRowClassName"
      highlight-current-row
      :header-cell-style="{ background: '#F0F3F7' }"
      v-bind:data="tableData"
      border
      stripe
      @current-change="handleCurrentChange"
      @row-dblclick="handleConfirm"
      @sort-change="handleSortChange"
      v-loading="loading"
    >
      <el-table-column width="55">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row == currentRow"></i>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        v-for="display in displayFields"
        v-bind:key="display.name"
        :prop="display.name"
        :label="display.label"
        :width="display.width"
      ></el-table-column>
      <template slot="empty">
        <!-- <img style="margin-top: 50px" src="../../../src/assets/imgs/home/no-order.png" alt /> -->
        <rt-portal-icon name="rt-portal-no-order" size="200"></rt-portal-icon>
        <p class="nodata-prompt">
          {{
            $tx("Sorry！未找到相应结果哦~换个关键词试试！", "common.nofindData")
          }}
        </p>
      </template>
    </el-table>
    <div slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleIndexChange"
        :current-page="pageIndex"
        :page-size="pageSize"
        :page-sizes="pageSizes"
        :layout="layout"
        :total="totalRecordCount"
        style="margin-bottom: 10px; text-align: center"
      ></el-pagination>
      <span class="dialog-footer">
        <el-button @click="handleReset">{{
          $tx("移除值", "lookup.remove")
        }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{
          $tx("确 定", "filter.confirm")
        }}</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "RtNewLookupDialog",
  props: {
    entity: {
      type: String,
      required: true,
    },
    requestUrl: {
      type: String,
      default: function () {
        return "../api/crmlookupview/data";
      },
    },
    nameField: {
      type: String,
      default: function () {
        return "new_name";
      },
    },
    idField: {
      type: String,
      default: function () {
        return this.entity + "id";
      },
    },
    displayFields: {
      type: Array,
      default: function () {
        return [
          { name: "new_name", label: this.$tx("名称", "lead.contactName") },
          {
            name: "createdon",
            label: this.$tx("创建时间", "contact.createTime"),
            width: 180,
          },
        ];
      },
    },
    orderbyFields: {
      type: String,
      default: function () {
        return "createdon desc";
      },
    },
    customConditions: {
      type: String,
      default: function () {
        return "";
      },
    },
    filterFields: {
      type: String,
      default: function () {
        return "new_name";
      },
    },
    returnFields: {
      type: String,
    },
    dialogCallback: Function,
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,

      filterValue: "",

      pageIndex: 1,
      pageSize: 20,
      layout: "total, sizes, prev, pager, next",
      pageSizes: [10, 20, 30, 40, 50],
      totalRecordCount: 0,

      tableData: [],
      currentRow: null,
    };
  },
  computed: {
    dialogTitle() {
      return this.$tx("查找", "查找");
    },
    selectString: {
      get() {
        //将idField、nameField、displayFields、returnFields合并，并去掉重复的字段
        var selectFields;

        if (this.returnFields) {
          selectFields = this.returnFields.split(",");
        } else {
          selectFields = [];
        }

        selectFields.push(this.nameField);
        selectFields.push(this.idField);

        for (var i in this.displayFields) {
          var fieldName = this.displayFields[i].name;
          if (selectFields.indexOf(fieldName) >= 0) {
            continue;
          }
          selectFields.push(fieldName);
        }
        return selectFields.join(",");
      },
    },
    orderbyString: {
      get() {
        return this.orderbyFields;
      },
    },
    conditionString: {
      get() {
        return this.customConditions;
      },
    },
    filterString: {
      get() {
        return this.filterFields;
      },
    },
  },
  mounted() {},
  methods: {
    //在methods总通过方法计算返回对应class样式
    tabRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "even-row";
      }
    },
    show() {
      this.dialogVisible = true;

      this.pageIndex = 1;
      this._fetchRecords();
    },
    handleSearch() {
      this.pageIndex = 1;
      this._fetchRecords();
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    handleSortChange() {
      alert(this.$tx("未实现", "lookup.notImplemented"));
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;

      this._fetchRecords();
    },
    handleIndexChange(pageIndex) {
      this.pageIndex = pageIndex;

      this._fetchRecords();
    },
    handleReset() {
      var lookupValue = {
        name: null,
        id: null,
        logicalname: null,
      };
      this.$emit("data-selected", lookupValue);

      this.dialogVisible = false;
      if (this.dialogCallback) {
        this.dialogCallback(lookupValue);
      }
    },
    handleConfirm() {
      var selectedRow = this.$refs.lookupTable.store.states.currentRow;
      if (rt.isNull(selectedRow)) {
        rt.showErrorToast(
          this.$tx("common.noRecordSelected", "请选择一条记录")
        );
        return;
      }
      var retValue = selectedRow;
      //  var retValue = {
      //       id: selectedRow[this.idField],
      //       name: selectedRow[this.nameField],
      //     };

      retValue["name"] = selectedRow[this.nameField];
      retValue["id"] = selectedRow[this.idField];
      retValue["logicalname"] = this.entity;

      if (this.returnFields) {
        var fieldList = this.returnFields.split(",");
        for (var i in fieldList) {
          retValue[fieldList[i]] = selectedRow[fieldList[i]];
        }
      }
      this.$emit("data-selected", retValue);
      this.dialogVisible = false;
      if (this.dialogCallback) {
        this.dialogCallback(retValue);
        // this.dialogCallback(selectedRow);
      }
    },
    //数据加载
    _fetchRecords() {
      this.loading = true;
      var isUrl = false;
      if (this.requestUrl) {
        if (this.requestUrl.split("?").length > 1) {
          isUrl = true;
        } else {
          isUrl = false;
        }
      }
      var requestStr =
        this.requestUrl +
        (isUrl ? "&entityName=" : "?entityName=") +
        this.entity +
        "&page=" +
        this.pageIndex +
        "&count=" +
        this.pageSize +
        "&select=" +
        this.selectString +
        "&orderby=" +
        this.orderbyString +
        "&condition=" +
        this.conditionString +
        "&filter=" +
        this.filterString +
        "&filterValue=" +
        encodeURIComponent(this.filterValue || "");

      rt.get(requestStr)
        .then((res) => {
          this.tableData = res.Data;
          this.totalRecordCount = res.TotalRecordCount;
          this.$nextTick(() => {
            this.$refs.lookupTable.doLayout();
          });
          this.loading = false;
        })
        .catch((error) => {
          rt.showErrorToast(error);
          this.loading = false;
        });
    },
  },
};
</script>

<style>
.rt-lookup-dialog .el-dialog {
  min-width: 700px;
  width: 45%;
  margin-top: 12vh !important;
}

.rt-lookup-dialog .el-form-item .el-form-item__label {
  width: 120px;
}

.rt-lookup-dialog .el-form-item .el-form-item__label:before {
  display: none;
}

.rt-lookup-dialog .el-form-item .el-form-item__content {
  margin-left: 120px !important;
}

.rt-lookup-dialog .el-table {
  margin-top: 15px;
}

.rt-lookup-dialog .el-dialog__body {
  padding-bottom: 15px;
}
.el-input__validateIcon {
  /* pointer-events: none; */
  display: none !important;
}
</style>




// WEBPACK FOOTER //
// lookup-dialog.vue?7ee00d64